module.exports = __webpack_public_path__ + "static/media/logo2.9129cc17.png";